import NotificationIcon from '~/components/notification-icon.vue';
import { POSITION } from 'vue-toastification';

/** @type {import('@nuxt/types').Plugin} */
export default (_context, inject) => {
    /**
     * @param {string} type The icon type.
     * @return {import('vue').Component}
     */
    const customIcon = type => ({
        render: createElement => createElement(NotificationIcon, { props: { type } }),
    });

    const getContainer = () => {
        return /** @type {HTMLElement} */(document.querySelector('#global-notification-container'));
    };

    /**
     * Dismiss toasts of the same type
     * @type {import('vue-toastification/dist/types/src/types').PluginOptions['filterBeforeCreate']}
     */
    const filterBeforeCreate = (toast, toasts) => {
        let delay = false;
        toasts.forEach(t => {
            if (t.type === toast.type) {
                t.eventBus?.$emit('dismiss', t.id);
                delay = true;
            }
        });

        if (delay) {
            getContainer().classList.add('vue-toastifications-delay');
        } else {
            getContainer().classList.remove('vue-toastifications-delay');
        }

        return toast;
    };

    /** @type {import('vue-toastification/dist/types/src/types').PluginOptions} */
    const defaults = {
        closeButton: 'button',
        closeButtonClassName: 'theme-white theme-transparent',
        container: getContainer,
        containerClassName: 'vue-toastifications-container',
        filterBeforeCreate,
        hideProgressBar: true,
        position: POSITION.TOP_CENTER,
        timeout: 10000,
        toastClassName: ['border-radius-large', 'font-size-small', 'align-center'],
        toastDefaults: {
            error: {
                icon: customIcon('error'),
            },
            info: {
                icon: customIcon('info'),
            },
            success: {
                icon: customIcon('success'),
            },
        },
        transition: 'Vue-Toastification__fadeInOut',
    };

    inject('toastDefaults', defaults);
};
